// eslint-disable-next-line no-useless-escape
const ALLOWABLE_REGEXP = /^[a-zA-Z =!+\/\\[\]|.()<>0-9"'\-_#@]*$/;
/*
  FIXME

  The "ASSIGNMENT_REGEXP" will fail for some assignments. e.g.

  context.page='hello';

  Solution 1: Call Prettier on front and backend for JS blobs
  Solution 2: Define a better regex
  Solution 3: Kill all JS editors
 */
const ASSIGNMENT_REGEXP = / = /;
const BANNED_STRINGS = ['alert(', 'fetch', 'XMLHttpRequest', '$.', 'ajax'];
const MAX_CONDITION_LENGTH = 500;
const isAllowable = (condition) => {
    const containsBannedString = BANNED_STRINGS.some((v) => condition.includes(v));
    const checks = [
        condition.length < MAX_CONDITION_LENGTH,
        ALLOWABLE_REGEXP.test(condition),
        !containsBannedString,
        !ASSIGNMENT_REGEXP.test(condition),
    ];
    return checks.every((check) => check);
};
const JS = {
    isAllowable,
};
export default JS;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXRpbC9qcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNkNBQTZDO0FBQzdDLE1BQU0sZ0JBQWdCLEdBQUcsd0NBQXdDLENBQUM7QUFFbEU7Ozs7Ozs7Ozs7R0FVRztBQUNILE1BQU0saUJBQWlCLEdBQUcsS0FBSyxDQUFDO0FBQ2hDLE1BQU0sY0FBYyxHQUFHLENBQUMsUUFBUSxFQUFFLE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxJQUFJLEVBQUUsTUFBTSxDQUFDLENBQUM7QUFDM0UsTUFBTSxvQkFBb0IsR0FBRyxHQUFHLENBQUM7QUFFakMsTUFBTSxXQUFXLEdBQUcsQ0FBQyxTQUFpQixFQUFFLEVBQUU7SUFDeEMsTUFBTSxvQkFBb0IsR0FBRyxjQUFjLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDL0UsTUFBTSxNQUFNLEdBQUc7UUFDYixTQUFTLENBQUMsTUFBTSxHQUFHLG9CQUFvQjtRQUN2QyxnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQ2hDLENBQUMsb0JBQW9CO1FBQ3JCLENBQUMsaUJBQWlCLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQztLQUNuQyxDQUFDO0lBQ0YsT0FBTyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsS0FBYyxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUNqRCxDQUFDLENBQUM7QUFFRixNQUFNLEVBQUUsR0FBRztJQUNULFdBQVc7Q0FDWixDQUFDO0FBRUYsZUFBZSxFQUFFLENBQUMifQ==